import { Option } from '../components/inputs/select/options';

export const getCategoryOptionsUtil = (categories: any[]): Option[] => {
  return categories.map((cat) => ({
    itemName: `${Array.from(Array(cat.depth))
      .map(() => '- ')
      .join('')} ${cat.category_title}`,
    id: cat.category_id,
  }));
};
